/**
 * Local Expert Tips Panel Plugin
 *
 * Registers the "local expert tips" side panel. The panel streams a second answer
 * from `/api/v1/query-responder-tips/` for an answer whose Query Responder stream
 * reported `metadata.has_local_expert_tip: true`, and renders it as an anonymous
 * card (typewriter body, loading row).
 */

import { registerPanel } from '../registry.js';
import { mountTipsView } from './tipsView.js';
import { IconTips } from '../../components/Icons.js';

registerPanel({
  type: 'tips',

  icon: IconTips,

  label: (t) => t('tips_available'),

  /**
   * Local expert tips can be switched off per host via `config.localExpertTips.enabled = false`.
   *
   * @param {Object} config - The global widget configuration.
   * @returns {boolean}
   */
  isEnabled(config) {
    return config?.localExpertTips?.enabled !== false;
  },

  /**
   * Mounts the tips transcript view into the given container element.
   *
   * @param {HTMLElement} container - The DOM element to render into.
   * @param {Object} data - Tips state of the message: { content, pending, streaming, error, empty }.
   * @param {Object} ctx - Context: { t, config, onRetry, onAction }.
   * @returns {{ destroy: Function, update: Function }}
   */
  mount(container, data, ctx) {
    return mountTipsView(container, data, ctx);
  }
});
